// import React from 'react';
import { APPI_JP_LOGO, CCPA_LOGO, GDPR_LOGO, HIPAA_LOGO, ISO_LOGO, SOC2_LOGO, SSL_LOGO } from '../auth-logo';

export const TOOL_ENTRIES_EN = [
  {
    label: 'Audio to Text Converter',
    url: '/en/tools/audio-to-text-converter',
  },
  {
    label: 'Online Video Converter',
    url: '/en/tools/online-video-converter',
  },
  {
    label: 'Online Audio Converter',
    url: '/en/tools/online-audio-converter',
  },
  {
    label: 'Online Vocal Remover',
    url: '/en/tools/online-vocal-remover',
  },
];

export const TOOL_ENTRIES_JA = [
  {
    label: 'オンライン音声文字起こしコンバーター',
    url: '/tools/audio-to-text-converter',
  },
  {
    label: 'フリーオンライン動画変換',
    url: '/tools/online-video-converter',
  },
  {
    label: 'オンライン音声変換',
    url: '/tools/online-audio-converter',
  },
  {
    label: 'ボーカルリムーバー',
    url: '/tools/online-vocal-remover',
  },
];

export const USE_CASES_ENTRIES_JA = [
  {
    label: '聴覚障がい者',
    url: '/use-cases/hearing-impaired',
  },
  {
    label: '営業担当',
    url: '/use-cases/business',
  },
  {
    label: 'ライター',
    url: '/use-cases/writer',
  },
  {
    label: '学生',
    url: '/use-cases/student',
  },
];

export const SECURITY_LOGOS = [
  {
    src: GDPR_LOGO,
    alt: 'GDPR（EU一般データ 保護規則）',
  },
  {
    src: SSL_LOGO,
    alt: 'SSL暗号化（Secure Sockets Layer）',
  },
  {
    src: SOC2_LOGO,
    alt: 'SOC 2 Type II',
  },
  {
    src: ISO_LOGO,
    alt: 'ISO 27001 certified',
  },
  {
    src: HIPAA_LOGO,
    alt: 'HIPAA法',
  },
  {
    src: CCPA_LOGO,
    alt: 'CCPA（カリフォルニア州新プライバシー法）',
  },
  {
    src: APPI_JP_LOGO,
    alt: 'APPI（日本個人情報保護法）',
  },
];
